import {
  successfulBiddersList,
  deactivateBidder
} from '@/febos/servicios/api/aduanas/successfulBidders';

export const getSuccessfulBidders = async ({ commit }, {
  page, items, filters, order
}) => {
  commit('SET_SUCCESSFUL_BIDDERS', []);
  const response = await successfulBiddersList({
    page, items, filters, order
  });
  const { documentos: adjudicatarios, totalPaginas, totalElementos } = response.data;
  commit('SET_SUCCESSFUL_BIDDERS', adjudicatarios);
  commit('SET_PAGINATION', { items: totalElementos, pages: totalPaginas });
  return response.data;
};
export const selectSuccessfulBidderState = ({ commit }, bidder) => {
  commit('SET_SELECTED_SUCCESSFUL_BIDDER', bidder);
};

export const attemptDeactivateBidder = async ({ commit }, id) => {
  try {
    commit('SET_LOADING', true);
    const response = await deactivateBidder(id);
    commit('UPDATE_STATUS_BIDDER', response.data);
    return response;
  } finally {
    commit('SET_LOADING', false);
  }
};
